import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  btnBorder: {
    // border: "solid 1px #ACACAC",
    // color: "#6D635F",
    // margin: "0 5px",
    width: 115,
    background: '#F0F2F6',
    borderRadius: 0,
  },
  selectedBtnColor: {
    // background: theme.palette.secondary.main,
    // color: "#fff",
    // margin: "0 5px",
    background: '#fff',
    fontWeight: 500,
    borderBottom: 'solid 2px #ED964D',
    marginBottom: -2,
    padding: '0px 25px',
    position: 'relaive',
    "&:before": {
      content: "' '",
      width: 7,
      height: 7,
      padding: 3,
      position: 'absolute',
      background: '#ED964D',
      zIndex: 1000,
      top: 5,
      right: 5,
      borderRadius: 100,

    }
  },
  // "&:hover": {
  //   background: theme.palette.secondary.main,
  // },
  "selectedBtnColor:last-child": {
    borderRadius: '0 8px 8px 0',
  },

  gridOrder: {
    [theme.breakpoints.down("xs")]: {
      order: 2,
    },
  },
  footer: {
    float: "right"
  },
  footerLogo: {
    height: 19,
    width: 50,
    marginLeft: 10,
  },
  btnGroup: {
    // width:'115px',
    border: 'solid 2px #F0F0F0',
    borderRadius: '8px 0px 0px 8px',
  },
  placeholderContent: {
    width: '100%',
    background: 'transparent linear-gradient(1deg, #F0F2F6 0%, #FFFEFE 100%) 0% 0% no-repeat padding-box',
    borderRadius: 10,
    height: '70vh',
    "& button": {
      padding: '10px 24px'
    }
  },
  paraContent: {
    color: '#707E8C',
    margin: '5px 0 20px'
  },
  placeholderImg: {
    width: 100,
    marginBottom: 10,
  },
  previewIndicator: {
    position: "fixed",
    left: 0,
    bottom: 0,
    color: "#fff",
    "& svg": {
      width: 50,
      height: 28
    }
  }
}));

export default useStyles;
